import { gql } from "@apollo/client";

export const addEmpowerMeBundle = gql`
  mutation addEmpowerMeBundle($record: CreateOneEmpowerTaskBundleInput!) {
    empowerMeTaskBundle_CreateOne(record: $record) {
      record {
        _id
      }
    }
  }
`;

export const updateEmpowerMeBundle = gql`
  mutation updateEmpowerMeBundle($_id: MongoID!, ,$record: UpdateByIdEmpowerTaskBundleInput!) {
    empowerMeTaskBundle_UpdateById(_id :$_id, record: $record) {
      record {
        _id
      }
    }
  }
`;

export const removeEmpowerMeBundle = gql`
  mutation removeEmpowerMeBundle($_id: MongoID!) {
    empowerMeTaskBundle_RemoveById(_id : $_id) {
      record {
        _id
      }
    }
  }
`;

export const addEmpowerMeBundlePersonal = gql`
  mutation addEmpowerMeBundlePersonal($record: CreateOneEmpowerTaskBundleInput!) {
    empowerMeTaskBundle_CreateOne_User(record: $record) {
      record {
        _id
      }
    }
  }
`;

export const updateEmpowerMeBundlePersonal = gql`
  mutation updateEmpowerMeBundlePersonal($_id: MongoID!, ,$record: UpdateByIdEmpowerTaskBundleInput!) {
    empowerMeTaskBundle_UpdateById_User(_id :$_id, record: $record) {
      record {
        _id
      }
    }
  }
`;

export const removeEmpowerMeBundlePersonal = gql`
  mutation removeEmpowerMeBundlePersonal($_id: MongoID!) {
    empowerMeTaskBundle_RemoveById_User(_id : $_id) {
      record {
        _id
      }
    }
  }
`;

export const addEmpowerMeBundleCategory = gql`
  mutation addEmpowerMeBundleCategory($record: CreateOneEmpowerTaskBundleCategoryInput!) {
    empowerMeTaskBundleCategory_CreateOne(record: $record) {
      record {
        _id
      }
    }
  }
`;

export const updateEmpowerMeBundleCategory = gql`
  mutation updateEmpowerMeBundleCategory($_id: MongoID!, ,$record: UpdateByIdEmpowerTaskBundleCategoryInput!) {
    empowerMeTaskBundleCategory_UpdateById(_id :$_id, record: $record) {
      record {
        _id
      }
    }
  }
`;

export const removeEmpowerMeBundleCategory = gql`
  mutation removeEmpowerMeBundleCategory($_id: MongoID!) {
    empowerMeTaskBundleCategory_RemoveById(_id : $_id) {
      record {
        _id
      }
    }
  }
`;